import script from "./RecapPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./RecapPanel.vue?vue&type=script&setup=true&lang=js"

import "./RecapPanel.vue?vue&type=style&index=0&id=71d3accd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d3accd"]])

export default __exports__